import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { AlertTriangleIcon, FileXIcon, TrendingUpIcon } from 'lucide-react';
export function ExecutiveSummary() {
  return <SlideLayout data-id="element-151">
      <div className="mb-6 sm:mb-12" data-id="element-152">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full" data-id="element-153" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-154">
          Executive Summary
        </h2>
        <p className="text-sm sm:text-xl text-slate-500 max-w-3xl" data-id="element-155">
          A high-level overview of your current digital footprint and the path
          to growth.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-12" data-id="element-156">
        <div className="glass-card p-5 sm:p-8 relative overflow-hidden group" data-id="element-157">
          <div className="absolute top-0 right-0 p-4 sm:p-6 opacity-[0.03] group-hover:opacity-[0.06] transition-opacity" data-id="element-158">
            <AlertTriangleIcon className="w-16 sm:w-24 h-16 sm:h-24 text-slate-900" data-id="element-159" />
          </div>
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-red-500/10 flex items-center justify-center mb-4 sm:mb-6 border border-red-500/20" data-id="element-160">
            <AlertTriangleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-red-500" data-id="element-161" />
          </div>

          <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-162">
            Technical & SEO Issues
          </h3>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-163">
            Your website has critical technical issues including HTTP errors,
            missing meta descriptions, missing H1 tags, unminified JavaScript,
            and missing alt text — all limiting organic visibility and
            crawlability.
          </p>
        </div>

        <div className="glass-card p-5 sm:p-8 relative overflow-hidden group" data-id="element-164">
          <div className="absolute top-0 right-0 p-4 sm:p-6 opacity-[0.03] group-hover:opacity-[0.06] transition-opacity" data-id="element-165">
            <FileXIcon className="w-16 sm:w-24 h-16 sm:h-24 text-slate-900" data-id="element-166" />
          </div>
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-orange-500/10 flex items-center justify-center mb-4 sm:mb-6 border border-orange-500/20" data-id="element-167">
            <FileXIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500" data-id="element-168" />
          </div>
          <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-169">
            Missing Revenue Pages
          </h3>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-170">
            The site lacks dedicated service pages, location-specific landing
            pages, and a blog section — the highest-converting page types in the
            mortgage industry that drive local traffic and leads.
          </p>
        </div>

        <div className="glass-card p-5 sm:p-8 relative overflow-hidden group sm:col-span-2 md:col-span-1" data-id="element-171">
          <div className="absolute top-0 right-0 p-4 sm:p-6 opacity-[0.03] group-hover:opacity-[0.06] transition-opacity" data-id="element-172">
            <TrendingUpIcon className="w-16 sm:w-24 h-16 sm:h-24 text-slate-900" data-id="element-173" />
          </div>
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-green-500/10 flex items-center justify-center mb-4 sm:mb-6 border border-green-500/20" data-id="element-174">
            <TrendingUpIcon className="w-5 h-5 sm:w-6 sm:h-6 text-green-500" data-id="element-175" />
          </div>
          <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-176">
            Growth Opportunity
          </h3>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-177">
            A focused SEO, content, and CRO strategy can significantly improve
            rankings, local search visibility, and qualified lead generation —
            turning your website into a lead generation engine.
          </p>
        </div>
      </div>

      <div className="bg-slate-100 border-l-4 border-gold-500 rounded-r-xl p-4 sm:p-8 shadow-sm" data-id="element-178">
        <h4 className="text-xs sm:text-sm font-bold text-gold-600 uppercase tracking-widest mb-2 sm:mb-3" data-id="element-179">
          What This Means for Your Business
        </h4>
        <p className="text-sm sm:text-lg text-slate-700 leading-relaxed" data-id="element-180">
          Cutting Edge Lending is not ranking for high-intent keywords such as
          "mortgage broker + city," losing local traffic to competitors with
          better optimization. With poor mobile performance (61/100), weak CTAs,
          no blog section, and limited content, the site is leaving significant
          revenue on the table. With targeted technical fixes, dedicated service
          and location pages, and conversion optimization, your website can
          become your strongest lead generation asset.
        </p>
      </div>
    </SlideLayout>;
}